'use client';

import { ServiceLayer } from '@packages/cms-components/src/modules/ServiceLayer/ServiceLayer';
import { Image } from '@packages/shared/src/ui/Image/Image';
import { Dialog } from '@packages/shared/src/ui/Dialog/Dialog';
import { DialogContent } from '@packages/shared/src/ui/Dialog/DialogContent/DialogContent';
import { DialogHeader } from '@packages/modules/src/Dialog/DialogHeader/DialogHeader.client';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type { GTMEventGlycerinDisplayOverlay } from '@packages/tracking/src/types/events';
import { useState } from 'react';

export type AdditionalInfoItemProps = {
  icon: null | string | React.ReactNode;
  serviceLayerId: null | string;
  text: string | React.ReactNode;
  dialogTitle?: string;
};

export const AdditionalInfoItem = ({
  icon,
  serviceLayerId,
  text,
  dialogTitle = '',
}: AdditionalInfoItemProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const dispatchGTMEvent = useTracking();

  const handleClick = () => {
    setIsDialogOpen(true);
    dispatchGTMEvent<GTMEventGlycerinDisplayOverlay>({
      event: 'DisplayOverlay',
      DisplayOverlayData: {
        category: 'dv-service-layer-legal-hints-item',
        label: dialogTitle,
      },
    });
  };

  const dialogCloseHandler = () => {
    setIsDialogOpen(false);
  };

  return (
    <>
      <div
        className={`flex flex-row items-center gap-2 ${serviceLayerId ? 'cursor-pointer' : ''}`}
        {...(serviceLayerId && {
          onClick: handleClick,
          role: 'button',
        })}
      >
        {typeof icon === 'string' ? (
          <Image src={icon} alt="" height={24} width={24} unoptimized />
        ) : (
          icon
        )}
        <div className="text-size-body2">{text}</div>
      </div>
      {serviceLayerId !== null && (
        <Dialog title={dialogTitle} isOpen={isDialogOpen} onClose={dialogCloseHandler}>
          <DialogHeader onClose={dialogCloseHandler}>{dialogTitle}</DialogHeader>
          <DialogContent className="p-2">
            <ServiceLayer serviceLayerId={serviceLayerId} />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
